<template>
    <main class="d-flex flex-column justify-content-between bgray-100 mh-100 vh-100">
        <b-navbar class="py-3 px-4 px-md-5"
                  toggleable="sm"
        >
            <b-navbar-brand class="header-logo cursor" @click="restart">
                <b-img class="w-100" :src="require('@shared/assets/img/common/QuantifiedESG_Logo_v3_Basic.png')"/>
            </b-navbar-brand>

            <b-navbar-nav class="ml-auto">
                <dropdownLanguage :disabled="register_loading"/>
            </b-navbar-nav>
        </b-navbar>
        <b-container class="bgray-100 py-3 my-auto" fluid>
            <b-row align-h="center" class="mb-3">
                <b-col cols md="8" xl="6">
                    <div class="text-center">
                        <h2 class="fw-600 mb-0"> {{ $t('공급망 ESG 실사') }} </h2>
                    </div>
                </b-col>
            </b-row>

            <b-row align-h="center" align-v="end" class="mb-4">
                <b-col cols md="8" xl="6">
                    <b-row align-v="end">
                        <b-col v-for="step in steps" :key="step.no" cols="4" md>
                            <div class="pb-1"
                                 :class="current_step === step.no
                                     ? 'border-bottom border-color-gray-700 border-width-2 fw-600 f-120 gray-900'
                                     : 'border-bottom border-color-gray-700 f-105 gray-600'">
                                <div class="f-90 mb-0">Step {{ step.no }}.</div>
                                <div>{{ $t(step.label) }}</div>
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>

            <b-row align-v="end" align-h="center">
                <b-col cols md="8" xl="6">
                    <b-card class="px-lg-3 px-lg-4 py-3 shadow-sm">
                        <DuplicatedRequestInfo v-if="duplicated"/>
                        <template v-else>
                            <RegisterStep1 v-if="register_step === 1"/>
                            <RegisterStep2 v-else-if="register_step === 2"/>
                            <RegisterStep3 v-else-if="register_step === 3"/>
                        </template>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>

        <RegisterInquiryModal/>
        <global-footer/>
    </main>
</template>

<script>
import GlobalFooter from '@shared/components/common/GlobalFooter.vue';
import dropdownLanguage from '@shared/components/utils/dropdown-language.vue';
import RegisterStep1 from '@/components/auth/Register/_SubComponents/RegisterStep1/RegisterStep1.vue';
import {mapActions, mapState} from 'vuex';
import RegisterStep2 from '@/components/auth/Register/_SubComponents/RegisterStep2/RegisterStep2.vue';
import RegisterStep3 from '@/components/auth/Register/_SubComponents/RegisterStep3.vue';
import RegisterInquiryModal from '@/components/auth/Register/_SubComponents/RegisterInquiryModal.vue';
import DuplicatedRequestInfo from '@/components/auth/Register/_SubComponents/DuplicatedRequestInfo.vue';

export default {
    name: 'register',
    components: {
        DuplicatedRequestInfo,
        RegisterInquiryModal,
        RegisterStep3,
        RegisterStep2,
        RegisterStep1,
        GlobalFooter,
        dropdownLanguage,
    },
    data() {
        return {
            steps: [
                {no: 1, label: '기업 조회'},
                {no: 2, label: '정보 입력'},
                {no: 3, label: '신청완료'},
            ],
        };
    },
    computed: {
        ...mapState('register', ['register_step', 'register_loading', 'duplicated']),
        // 중복 신청 안내는 Step 2(이메일 확인)에서 나오므로 Step 2 에 불을 켠다
        current_step() {
            return this.duplicated ? 2 : this.register_step;
        },
    },
    async created() {
        // 테넌트별 register 런타임 설정 (brands DB) — 실패해도 코드 기본값으로 동작
        this.$store.dispatch('register/loadTenantRegisterConfig');

        if (this.$store.state.accessToken) {
            await this.$store.dispatch('logout');
        }

        // ?l= 은 앱이 문구를 가진 locale(@shared/locales/*.json) 이면 그대로 받는다.
        // 'ch' 는 이미 배포된 링크의 옛 중국어 코드라 'ca' 로 바꾼다. 모르는 값은 en.
        const query_lang = {ch: 'ca'}[this.$route.query.l] || this.$route.query.l;
        this.$i18n.locale = !query_lang
            ? 'ko'
            : this.$i18n.availableLocales.includes(query_lang) ? query_lang : 'en';
    },
    mounted() {
        this.initiateAllData();
    },
    beforeDestroy() {
        this.initiateAllData();
    },
    methods: {
        ...mapActions('register', ['initiateAllData']),
        // 로고: 처음부터 다시. 서버 요청이 나가 있는 동안은 결과가 엉뚱한 화면에 반영되므로 막는다.
        restart() {
            if (this.register_loading) return;
            this.initiateAllData();
        },
    }
};

</script>

<style>
#vendor-table .b-table-row-selected.table-active {
    background-color: #b9deff38 !important;
}

.not-scroll {
    overflow: hidden;
    width: 100%;
    height: 100vh;
    touch-action: none;
}
</style>
